module.exports = __webpack_public_path__ + "media/images/panel-61f9cc3b39690b41132ef9bf80448f5f.png";